<template>
    <div class="contact_us">
        <!--banner start-->
        <div class="contact_banner"></div>
        <!--banner end-->

        <!--联系我们 start-->
        <div class="contact_us_content">
            <div class="contentWidth">
                <h2 class="contact_title">联系我们</h2>
                <div class="ly_flex ly_flex_just_between">
                    <div class="map_box" id="container"></div>
                    <div class="office_content">
                        <h3>西安智徽信息工程有限公司</h3>
                        <div class="office_content_list ly_flex ly_flex_ali_center"
                             v-for="item in officeContentList"
                             :key="item.key">
                            <img :src="item.icon" alt="">
                            <span>{{item.value}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!--联系我们 end-->
    </div>
</template>

<script>
    import AMap from 'AMap'
    export default {
        name: "contactUs",
        data() {
            return {
                officeContentList: [
                    {
                        icon: require('../../assets/img/phone.png'),
                        value: '029-85798677'
                    },
                    // {
                    //     icon: require('../../assets/img/mailbox.png'),
                    //     value: '873554431@qq.com'
                    // },
                    {
                        icon: require('../../assets/img/location.png'),
                        value: '西安市高新区国家数字出版基地B座4层402室'
                    }
                ]
            }
        },
        mounted(){
            let map = new AMap.Map('container',{
                zoom:15,
                center: [108.834339,34.211113],//中心点坐标
                viewMode:'3D'//使用3D视图
            });
            var marker = new AMap.Marker({
                position:[108.834339,34.211113],//位置
            })
            // marker.setTitle('我是marker的title');
            // marker.setLabel({
            //     offset: new AMap.Pixel(20, 20),  //设置文本标注偏移量
            //     content: "<div class='info'>我是 marker 的 label 标签</div>", //设置文本标注内容
            //     direction: 'right' //设置文本标注方位
            // });
            map.add(marker);//添加到地图
        }
    }
</script>

<style scoped lang="scss">
    .contact_us {
        .contact_banner {
            width: 100%;
            height: 306px;
            background: url("../../../public/img/contactUs/contact_banner.png");
            background-size: 100% 100%;
        }

        .contact_us_content {
            padding: 120px 0 0;
            width: 100%;
            height: 611px;

            .contact_title {
                margin-bottom: 72px;
                text-align: center;
                font-size: 40px;
                line-height: 40px;
                font-weight: 600;
                color: #333333;
            }

            .map_box {
                width: 664px;
                height: 302px;
                overflow: hidden;
            }

            .office_content {
                width: 452px;
                height: 302px;

                h3 {
                    margin-bottom: 115px;
                    font-size: 30px;
                    line-height: 30px;
                    color: #444444;
                }

                .office_content_list {
                    margin-bottom: 26px;

                    img {
                        margin-right: 27px;
                        width: 36px;
                        height: 36px;
                    }

                    span {
                        font-size: 18px;
                        line-height: 18px;
                        color: #444444;
                        white-space: nowrap;
                    }
                }
            }
        }
    }
</style>
